import React from 'react';
import ReactDOM from 'react-dom/client';
import OfficialHeader from'./components/official-header';
import OfficialFooter from'./components/official-footer';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import "./App.css";
import "./assets/sass/common.scss";
import Home2 from './page2/home2';
import IntroductionConsortium from './page2/introduction-consortium';
import Donation from './page2/donation/index.jsx';
import Project from "./page2/project/index.jsx"
import Methodological from "./page2/methodological/index.jsx"
import Announcement from "./page2/announcement/index.jsx"
import Notice from "./page2/announcement/components/notice.jsx"
import NoticeDetail from "./page2/announcement/components/notice-detail.jsx"
import Reference from "./page2/announcement/components/reference.jsx"
import ReferenceDetail from "./page2/announcement/components/reference-detail.jsx"
import Faq from "./page2/announcement/components/faq.jsx"
import './i18n';

// Official components
const OfficialLayout = () => {
  return (
    <div className="official-layout">
      <OfficialHeader />
      <Routes>
        <Route path="/official/home2" element={<Home2 />} />
        <Route path="/" element={<Home2 />} />
        <Route path="/project" element={<Project />} />
        <Route path="/methodological" element={<Methodological />} />
        <Route path="/introduction-consortium" element={<IntroductionConsortium />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/announcement" element={<Announcement />} >
          <Route index element={<Notice />} />
          <Route path="notice-detail" element={<NoticeDetail />} />
          <Route path="reference" element={<Reference />} />
          <Route path="reference-detail" element={<ReferenceDetail />} />
          <Route path="faq" element={<Faq />} />
        </Route>
      </Routes>
      <OfficialFooter />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <OfficialLayout />
      </Router>
    </Provider>
  </React.StrictMode>
);